<template>
  <div id="create-calculation-dialog">
    <res-dialog :showDialog="showHelp"
                titleClass="resBlue darken-1 white--text"
                iconColor="white"
                cancelButtonText="Close"
                :cancelButtonOnly="true"
                cancelButtonColor="resBlue darken-1"
                :maxWidth="800"
                :setWidth="800"
                :setHeight="600"
                @cancel="closeHelp">
      <budget-calculations-help :openSection="openHelpSection"></budget-calculations-help>
    </res-dialog>
    <res-dialog :showDialog="showDialog"
                title="Create Calculation"
                dialogClass="res-dialog-calc"
                titleClass="resBlue darken-1 white--text"
                attach="#create-calculation-dialog"
                iconColor="white"
                contentClass="res-dialog-calc"
                :setHeight="height"
                :maxWidth="maxWidth"
                :setWidth="width"
                saveButtonColor="resBlue darken-1"
                cancelButtonColor="resBlue darken-1"
                saveButtonText="Populate"
                cancelButtonText="Cancel"
                :saveDisabled="!calculateEnabled[calculationType]()"
                @save="save"
                @cancel="cancel">

      <v-container>
        <v-row class="my-2">
          <span class="mt-4">
            I want to populate the
            <a @click="openGLAccountListDialog">({{Object.keys(selectedObjects).length}}) GL Account(s)</a>
          </span>
          <v-col cols="7">
            <res-select v-model="calculationType" :items="calculationTypes"></res-select>
          </v-col>
          <v-col cols="2">
            <div class="help-controls bump-up" @click="openHelp(null)">
              <span class="help-label">Help</span>
              <v-icon color="var(--v-resBlue-darken1)" class="pb-1" small>mdi-help-circle</v-icon>
            </div>
          </v-col>
        </v-row>
        <v-divider></v-divider>

        <v-row v-if="calculationType == 1" class="my-2">
          <span class="mt-4">Starting in</span>
          <v-col cols="2">
            <res-select v-model="calculationMonth" :items="months"></res-select>
          </v-col>
          <span class="mt-4">use</span>
          <v-col cols="2">
            <res-select v-model="calculationBasis" :items="calculationBasii" placeholder=""></res-select>
          </v-col>
          <span class="mt-4">multiplied by an amount of</span>
          <v-col cols="1">
            <res-text-field round class="bump-up" v-model="calculationMultiplier" prependIcon="attach_money" placeholder="--"></res-text-field>
          </v-col>
          <span class="mt-4">multiplied by a rate/occurrence of</span>
          <v-col cols="1">
            <res-text-field round class="bump-up" v-model="calculationSecondaryMultiplier" appendText="%" placeholder="--"></res-text-field>
          </v-col>
        </v-row>

        <v-row v-if="calculationType == 2" class="my-2">
          <span class="mt-4">Starting in</span>
          <v-col cols="2">
            <res-select v-model="calculationMonth" :items="months"></res-select>
          </v-col>
          <span class="mt-4">use</span>
          <v-col cols="4">
            <res-select v-model="calculationBasis" :items="calculationBasii"></res-select>
          </v-col>
          <v-col cols="2">
            <res-select v-model="calculationOperation" :items="calculationOperations"></res-select>
          </v-col>
          <v-col cols="1">
            <res-text-field round class="bump-up" v-model="calculationMultiplier" placeholder="--"></res-text-field>
          </v-col>
          <v-col cols="2">
            <res-select v-model="calculationMultiplierDenomination" :items="denominationOptions"></res-select>
          </v-col>
        </v-row>

        <v-row v-if="calculationType == 3" class="my-2">
          <span class="mt-4">Starting in</span>
          <v-col cols="2">
            <res-select v-model="calculationMonth" :items="months"></res-select>
          </v-col>
          <span class="mt-4">use</span>
          <v-col cols="4">
            <res-select v-model="calculationBasis" :items="calculationBasii"></res-select>
          </v-col>
          <v-col cols="2" v-if="calculationBasis == 1">
            <res-select v-model="calculationOperation" :items="calculationOperations"></res-select>
          </v-col>
          <v-col cols="1" v-if="calculationBasis == 1">
            <res-text-field round class="bump-up" v-model="calculationMultiplier" placeholder="--"></res-text-field>
          </v-col>
          <v-col cols="2" v-if="calculationBasis == 1">
            <res-select v-model="calculationMultiplierDenomination" :items="denominationOptions"></res-select>
          </v-col>
        </v-row>

        <v-row v-if="calculationType == 4" class="my-2">
          <span class="mt-4">Starting in</span>
          <v-col cols="2">
            <res-select v-model="calculationMonth" :items="months"></res-select>
          </v-col>
          <span class="mt-4">use</span>
          <v-col cols="4">
            <res-select v-model="calculationBasis" :items="calculationBasii"></res-select>
          </v-col>
        </v-row>

        <v-row v-if="calculationType == 5" class="my-2">
          <span class="mt-4">Starting in</span>
          <v-col cols="2">
            <res-select v-model="calculationMonth" :items="months"></res-select>
          </v-col>
          <span class="mt-4">use</span>
          <v-col :cols="calculationBasis == 2 ? '3' : '4'">
            <res-select v-model="calculationBasis" :items="calculationBasii"></res-select>
          </v-col>
          <span class="mt-4" v-if="calculationBasis == 2">of</span>
          <v-col cols="2" v-if="calculationBasis == 2">
            <res-text-field round class="bump-up" v-model="calculationMultiplier" prependIcon="attach_money" placeholder="--"></res-text-field>
          </v-col>
          <span class="mt-4">multiplied by number of move-outs</span>
        </v-row>

        <v-row v-if="calculationType == 6" class="my-2">
          <span class="mt-4">Starting in</span>
          <v-col cols="2">
            <res-select v-model="calculationMonth" :items="months"></res-select>
          </v-col>
          <span class="mt-4">use</span>
          <v-col cols="5">
            <v-autocomplete class="bump-up" color="resBlue darken-1" v-model="calculationBasis" :items="calculationBasii" outlined dense flat></v-autocomplete>
          </v-col>
          <span class="mt-4">multiplied by</span>
          <v-col cols="2">
            <res-text-field round class="bump-up" v-model="calculationMultiplier" placeholder="--"></res-text-field>
          </v-col>
          <span class="mt-4">%</span>
        </v-row>
      </v-container>

      <res-dialog :showDialog="showisGLAccountListDialogOpen"
                  title="GL Accounts"
                  cancelButtonText="Close"
                  :cancelButtonOnly="true"
                  @cancel="closeGLAccountListDialog">
        <ul>
          <li v-for="objectKey in Object.keys(selectedObjects)"
              :key="objectKey">
            {{selectedObjects[objectKey].text}}
          </li>
        </ul>
      </res-dialog>
    </res-dialog>
  </div>
</template>

<script>
  import ResDialog from '@/components/base/ResDialog.vue';
  import ResSelect from '@/components/base/ResSelect.vue';
  import ResTextField from '@/components/base/ResTextField.vue';

  import BudgetCalculationsHelp from '@/components/help/BudgetCalculationsHelp.vue';
  import HelpableMixin from '@/mixins/Helpable.js';

  import propertyService from '@/services/property';
  import budgetGLAccountService from '@/services/budget-gl-account';
  import glAccountService from '@/services/gl-account';

  import { mapActions } from 'vuex';
  import { mapGetters } from 'vuex';

  export default {
    props: {
      height: {
        type: Number
      },
      maxWidth: {
        type: Number
      },
      showDialog: {
        type: Boolean
      },
      width: {
        type: Number
      },
      budgetIterationId: {
        type: String,
        default: null
      },
      fiscalYearStartMonth: {
        type: Number,
        default: 1
      },
      accountingBasisId: {
        type: Number,
        default: 1
      },
      objects: {
        type: Object,
        default: () => { }
      }
    },
    mixins: [HelpableMixin],
    data() {
      return {
        loading: false,
        showisGLAccountListDialogOpen: false,
        calculationType: 1,
        calculationMonth: 1,
        calculationBasis: null,
        calculationMultiplier: null,
        calculationMultiplierDenomination: 1,
        calculationSecondaryMultiplier: 0,
        calculationSecondaryMultiplierDenomination: 1,
        calculationOperation: 1,
        managementFees: [],
        calculateEnabled: {
          1: () => this.calculationMonth && this.calculationType && this.calculationBasis && this.calculationMultiplier && (this.calculationMultiplier > 0 || this.calculationMultiplier < 0) && this.calculationSecondaryMultiplier && (this.calculationSecondaryMultiplier > 0 || this.calculationSecondaryMultiplier < 0),
          2: () => this.calculationMonth && this.calculationType && this.calculationBasis && this.calculationOperation && this.calculationMultiplier && this.calculationMultiplierDenomination,
          3: () => this.calculationMonth && this.calculationType && this.calculationBasis && (this.calculationBasis === 2 || (this.calculationOperation && this.calculationMultiplier && (this.calculationMultiplier > 0 || this.calculationMultiplier < 0) && this.calculationMultiplierDenomination)),
          4: () => this.calculationMonth && this.calculationType && this.calculationBasis,
          5: () => this.calculationMonth && this.calculationType && this.calculationBasis && (this.calculationBasis === 1 || (this.calculationMultiplier && (this.calculationMultiplier > 0 || this.calculationMultiplier < 0))),
          6: () => this.calculationMonth && this.calculationType && this.calculationBasis && this.calculationMultiplier && (this.calculationMultiplier > 0 || this.calculationMultiplier < 0)
        },
        selectedObjects: {},
        glAccountOptions: []
      }
    },
    components: {
      BudgetCalculationsHelp,
      ResDialog,
      ResSelect,
      ResTextField
    },
    methods: {
      ...mapActions(['changeLoading']),
      updateSelectedObjects() {
        var selected = {};
        Object.keys(this.objects).map((objectKey) => {
          if (this.objects[objectKey].isSelected) {
            var obj = this.objects[objectKey];
            selected[objectKey] = { text: obj.glAccountName || obj.label, value: obj.glAccountId, secondaryIds: obj.workingRowIds || [] };
          }
        });
        this.selectedObjects = selected;
      },
      async getManagementFees() {
        var fees = await propertyService.getManagementFees(this.selectedPropertyId, this.budgetIterationId );
        this.managementFees = fees.map((fee) => { return { text: fee.name, value: fee.managementFeeId }; });
      },
      async getGLAccountOptions() {
        var glAccounts = await glAccountService.getGlAccounts();
        this.glAccountOptions = glAccounts
          .filter((gl) => { return gl.glAccountType == 'Income' || gl.glAccountType == 'Expense'; })
          .sort((glA, glB) => { if (glA.number < glB.number) { return -1; } if (glA.number > glB.number) { return 1; } return 0; })
          .map((gl) => { return { text: gl.number + ' - ' + gl.name, value: gl.glAccountId }; });
      },
      async save() {
        this.changeLoading(true);
        let succeeded = false;
        console.log(this.calculationSettings);
        succeeded = await budgetGLAccountService.createCalculation(this.budgetIterationId, this.selectedObjectIds, this.calculationSettings);

        this.$emit('save', succeeded);
        if (succeeded) {
          this.$eventHub.$emit('calculation-created', this.budgetIterationId);
          this.cancel();
        }
       this.changeLoading(false);
      },
      cancel() {
        this.$emit('cancel', true)
      },
      openGLAccountListDialog() {
        this.showisGLAccountListDialogOpen = true;
      },
      closeGLAccountListDialog() {
        this.showisGLAccountListDialogOpen = false;
      },
      reset() {
        this.calculationType = 1;
        this.calculationMonth = this.fiscalYearStartMonth;
          this.calculationBasis = null;
          this.calculationMultiplier = null;
          this.calculationMultiplierDenomination = 1;
          this.calculationSecondaryMultiplier = null;
          this.calculationSecondaryMultiplierDenomination = 1;
          this.calculationOperation = 1;
      }
    },
    computed: {
      ...mapGetters(['selectedPropertyId']),
      selectedObjectIds() {
        return Object.keys(this.selectedObjects).map((key) => { return { glAccountId: key, workingRowIds: this.selectedObjects[key].secondaryIds }; });
      },
      calculationSettings() {
        return {
          type: this.calculationType,
          month: this.calculationMonth,
          basis: this.calculationType === 4 ? 0 : (this.calculationType === 6 ? 0 : Number(this.calculationBasis)),
          multiplier: this.calculationMultiplier,
          multiplierDenomination: this.calculationMultiplierDenomination,
          secondaryMultiplier: this.calculationSecondaryMultiplier,
          secondaryMultiplierDenomination: this.calculationSecondaryMultiplierDenomination,
          operation: this.calculationOperation,
          managementFeeId: this.calculationType === 4 ? this.calculationBasis : null,
          glAccountIdOption: this.calculationType === 6 ? this.calculationBasis : null
        }
      },
      months() {
        return [
          { text: 'January', value: 1 },
          { text: 'February', value: 2 },
          { text: 'March', value: 3 },
          { text: 'April', value: 4 },
          { text: 'May', value: 5 },
          { text: 'June', value: 6 },
          { text: 'July', value: 7 },
          { text: 'August', value: 8 },
          { text: 'September', value: 9 },
          { text: 'October', value: 10 },
          { text: 'November', value: 11 },
          { text: 'December', value: 12 }
        ]
      },
      calculationTypes() {
        var calcTypes = [
          { text: `Using Occupied Units, Vacant Units, Total Units, Move-Ins, Move-Outs, or Renewals`, value: 1 },
          { text: `Starting with nothing, budget numbers, or current year actuals`, value: 2 },
          { text: `Using a Management Fee`, value: 4 },
          { text: `Using Turn Costs`, value: 5 },
          { text: `Using a Percent of the Budgeted amount for the Selected GL Account Chosen Below`, value: 6 }
        ];
        // Clone formula applies to whole GL so only add it if not opening the dialog for a working row
        if (this.selectedObjects && Object.keys(this.selectedObjects).every(key => this.selectedObjects[key].secondaryIds.length === 0))
        {
          calcTypes.splice(2, 0, { text: `By Cloning Existing Historical Row(s)`, value: 3 });
        }
        return calcTypes;
      },
      calculationBasii() {
        switch (this.calculationType) {
          case 1:
            return [
              { text: 'Occupied Units', value: 1 },
              { text: 'Vacant Units', value: 2 },
              { text: 'Total Units', value: 3 },
              { text: 'Move-Ins', value: 4 },
              { text: 'Move-Outs', value: 5 },
              { text: 'Renewals', value: 6 },
            ];
          case 2:
            return [
              { text: 'nothing', value: 1 },
              { text: 'budget numbers', value: 2 },
              { text: 'current year actuals - Monthly', value: 3 },
              { text: 'current year actuals - Quarterly Average', value: 4 },
              { text: 'current year actuals - Annual Average', value: 5 }
            ];
          case 3:
            return [
              { text: 'Historical Vendor rows with additional calculations', value: 1 },
              { text: 'Historical Vendor rows with no other calculations', value: 2 },
            ];
          case 4:
            return [
              { text: 'No Management Fee Selected', value: 0 }
            ].concat(this.managementFees);
          case 5:
            return [
              { text: 'PY annual expenses divided by PY move-outs', value: 1 },
              { text: 'a manual amount', value: 2 },
            ];
          case 6:
            return [
              { text: 'Selected GL Account', value: 0 }
            ].concat(this.glAccountOptions);
        }
        return []
      },
      calculationOperations() {
        return [
          { text: 'increased by', value: 1 },
          { text: 'decreased by', value: 2 },
          { text: 'multiplied by', value: 3 }
        ];
      },
      denominationOptions() {
        return [
          { text: 'dollars ($)', value: 1 },
          { text: 'percent (%)', value: 2}
        ];
      }
    },
    mounted() {
    },
    watch: {
      showDialog(newVal) {
        if (newVal) {
          this.reset();
          if (this.selectedPropertyId) {
            this.getManagementFees();
            this.getGLAccountOptions();
            this.updateSelectedObjects();
          } else {
            alert("Please select a property from the 'Browse Budgets' screen.")
            this.cancel();
          }
        }
      },
      calculationType(newVal) {
        // reset values
        this.calculationBasis = newVal === 4 || newVal === 6 ? 0 : newVal === 1 ? null : 1;
        this.calculationMultiplier = null;
        this.calculationMultiplierDenomination = 1;
        this.calculationSecondaryMultiplier = null;
        this.calculationSecondaryMultiplierDenomination = newVal === 1 ? 2 : 1;
        this.calculationOperation = newVal === 1 ? 3 : 1;
      }
    }
  };
</script>

<style scoped lang="scss">
  ul {
    list-style-type: none;
  }

  .help-controls {
    float: right;
    border: solid 1px var(--v-resGrey-lighten3);
    padding: 7px 6px 6px 6px;
    cursor: pointer;
  }

  .help-label {
    padding-right: 6px;
  }

  .bump-up {
    margin-top: -5px;
  }
</style>
<style>
  #create-calculation-dialog .v-dialog.v-dialog--active,
  #create-calculation-dialog .v-dialog.v-dialog--active .v-card__text.base-dialog {
    overflow: visible !important;
  }
</style>
